module.exports = __webpack_public_path__ + "static/media/Assets-08-Visualising-epilepsy-hero.eebc0161.jpg";